import React from 'react'
import SvgStyleSheet from './SvgStyleSheet'

const MAX_ZOOM = 3

export default ({ width, height, zoomTo, resetZoom, children, className }) => {
  const scale = zoomTo
    ? Math.min(
        width / (zoomTo[1][0] - zoomTo[0][0]),
        height / (zoomTo[1][1] - zoomTo[0][1]),
        MAX_ZOOM
      )
    : 1

  const translateX = zoomTo
    ? (width - (zoomTo[0][0] + zoomTo[1][0]) * scale) / 2
    : 0
  const translateY = zoomTo
    ? (height - (zoomTo[0][1] + zoomTo[1][1]) * scale) / 2
    : 0

  const transform = `matrix(${scale} 0 0 ${scale} ${translateX} ${translateY}) `
  const transform2 = `matrix(${scale}, 0, 0, ${scale}, ${translateX}, ${translateY}) `

  const helperRadius = Math.min(width, height) / 2 - 4
  const factor = Math.cos(Math.PI / 4)

  return (
    <svg
      className={`zoomMap ${className}`}
      viewBox={`0 0 ${width} ${height}`}
      preserveAspectRatio="xMaxYMin slice"
    >
      <defs>
        <clipPath id="clip-rect">
          <rect x="0" y="0" width={width} height={height} />
        </clipPath>
        <filter id="whiteblur">
          <feOffset in="SourceGraphic" result="offsetOut" />
          <feColorMatrix
            in="offsetOut"
            result="whiteOut"
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0 1"
          />
          <feGaussianBlur in="whiteOut" result="blurOut" stdDeviation="5" />
          <feBlend in="SourceGraphic" in2="blurOut" mode="normal" />
        </filter>
        <SvgStyleSheet />
      </defs>
      <g
        transform={transform}
        style={{ transform: transform2 }}
        className={zoomTo ? 'content zoomedIn' : 'content'}
      >
        {children}
      </g>
      <g className={zoomTo ? 'zoomHelper zoomedIn' : 'zoomHelper'}>
        <circle cx={width / 2} cy={height / 2} r={helperRadius} />
        <g
          transform={`translate(${width / 2 + helperRadius * factor} ${height /
            2 -
            helperRadius * factor})`}
          className="close"
        >
          <circle r="20" onClick={resetZoom} />
          <path d="M -10 -10 L 10 10 M 10 -10 L -10 10" />
        </g>
      </g>
    </svg>
  )
}



// WEBPACK FOOTER //
// ./src/components/ZoomMap.js